// Types
import { PERMISION } from "security"
import type { MenuType } from "../types"

export const accountsMenu = {
  menu: [
    {
      label: "REGISTER",
      link: "/accounts/register",
      permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
    },
    {
      label: "TRANSACTION",
      link: "#",
      permission: PERMISION.ACCOUNTS.TRANSACTION.PERMISION,
      children: [
        { label: "OPENING BALANCE", link: "/accounts/transaction/opening-balance", permission: PERMISION.ACCOUNTS.TRANSACTION.OPENING_BALANCE.PERMISION },
        { label: "GENERAL ENTRY", link: "/accounts/transaction/general-entry", permission: PERMISION.ACCOUNTS.TRANSACTION.GENERAL_ENTRY.PERMISION },
        { label: "CLOSING FINANCE YEAR", link: "/accounts/transaction/closing-finance-year", permission: PERMISION.ACCOUNTS.TRANSACTION.CLOSING_FINANCE_YEAR.PERMISION }
      ]
    },
    {
      label: "REPORT",
      link: "#",
      permission: PERMISION.ACCOUNTS.REPORT.PERMISION,
      children: [
        { label: "TRANSACTION DETAIL", link: "/accounts/report/transaction-detail", permission: PERMISION.ACCOUNTS.REPORT.TRANSACTION_DETAIL.PERMISION },
        { label: "BALANCE SHEET", link: "/accounts/report/profit-loss?tabs=balance-sheet", permission: PERMISION.ACCOUNTS.REPORT.BALANCE_SHEET.PERMISION },
        { label: "PROFIT AND LOSS", link: "/accounts/report/profit-loss?tabs=profit-loss", permission: PERMISION.ACCOUNTS.REPORT.PROFIT_AND_LOSS.PERMISION },
        { label: "BUDGET MANAGER", link: "/accounts/report/buget-manager", permission: PERMISION.ACCOUNTS.REPORT.BUDGET_MANAGER.PERMISION },
        { label: "BUDGET VARIANCE", link: "/accounts/report/buget-variance", permission: PERMISION.ACCOUNTS.REPORT.BUDGET_VARIANCE.PERMISION },
        { label: "DASHBOARD", link: "/accounts/report/dashboard", permission: PERMISION.ACCOUNTS.REPORT.DASHBOARD.PERMISION },
      ]
    },
    {
      label: "JOURNAL",
      link: "/accounts/journal",
      permission: PERMISION.ACCOUNTS.JOURNAL.PERMISION
    },
    {
      label: "FIND",
      link: "/accounts/find",
      permission: PERMISION.ACCOUNTS.FIND.PERMISION
    }
  ] as MenuType[]
}